import { useEffect, useState } from "react";
import { Bookmark, X } from "lucide-react";
import { format, parseISO } from "date-fns";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const toApi = (v) => ({ kind: v.kind, days: (v.days || []).map((d) => format(d, "yyyy-MM-dd")),
  range: v.range?.from ? { from: format(v.range.from, "yyyy-MM-dd"), to: format(v.range.to || v.range.from, "yyyy-MM-dd") } : {} });
const fromApi = (v) => (v.kind === "days" ? { kind: "days", days: v.days.map((d) => parseISO(d)) }
  : v.kind === "range" ? { kind: "range", range: { from: parseISO(v.range.from), to: parseISO(v.range.to) } } : { kind: v.kind });

export function SavedPicks({ value, basis, onApply }) {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  useEffect(() => { api.get("/date-filters").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const save = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/date-filters", { name, basis, value: toApi(value) });
      setItems((x) => [...x, data]); setName(""); toast.success("Saved");
    } catch (err) { toast.error(errMsg(err)); }
  };
  const del = (id) => api.delete(`/date-filters/${id}`).then(() => setItems((x) => x.filter((i) => i.id !== id))).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="border-t pt-2 px-1 space-y-2 max-w-[300px]" data-testid="saved-picks">
      <p className="text-[11px] uppercase tracking-wider text-slate-500 flex items-center gap-1"><Bookmark className="w-3 h-3" />Saved picks</p>
      {items.length > 0 && <div className="flex flex-wrap gap-1">
        {items.map((i) => (
          <span key={i.id} className="text-xs bg-slate-100 rounded-full pl-2 pr-1 py-0.5 flex items-center gap-1">
            <button onClick={() => onApply(fromApi(i.value), i.basis)} data-testid={`saved-pick-${i.id}`} className="hover:underline">{i.name}</button>
            <button aria-label="Delete saved pick" onClick={() => del(i.id)} data-testid={`saved-pick-delete-${i.id}`}><X className="w-3 h-3" /></button>
          </span>))}
      </div>}
      {value.kind !== "all" && <form onSubmit={save} className="flex gap-1">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name this pick" maxLength={40} className="h-8 text-xs" data-testid="saved-pick-name-input" />
        <Button type="submit" size="sm" className="h-8" disabled={!name.trim()} data-testid="saved-pick-save-btn">Save</Button>
      </form>}
    </div>
  );
}
